//
//
//
//
//
//
//
//


import { fetch } from '@/apis/scan'

export default {
    props: { scanInit: Boolean },
    data() {
        return {
            // isInit: false,
            scannerTimeout: null,
            scannerBuffer: "",
        }
    },
    name: 'WaitingScreen',
    mounted() {
        console.log(`output->this.scanInit`, this.scanInit)
        setTimeout(() => {
            this.initScannerListener();
        }, 200)
    },
    methods: {
        // 驗證條碼格式
        isValidBarcode(barcode) {
            if (barcode === '123123') {
                return true;
            }
            // 簡單的驗證：EAN-13應該是13位數字
            return /^\d{13}$/.test(barcode);
        },
        // 生成隨機的EAN-13條碼
        generateRandomEAN13() {
            let barcode = '2'; // 以2開頭（示例）
            for (let i = 0; i < 11; i++) {
                barcode += Math.floor(Math.random() * 10);
            }
            // 計算校驗位（簡化版）
            barcode += Math.floor(Math.random() * 10);
            return barcode;
        },
        playScanSound() {
            // 可以使用Web Audio API播放簡單的提示音
            try {
                const context = new (window.AudioContext || window.webkitAudioContext)();
                const oscillator = context.createOscillator();
                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(800, context.currentTime);
                oscillator.connect(context.destination);
                oscillator.start();
                oscillator.stop(context.currentTime + 0.1);
            } catch (e) {
                console.log('音頻播放不支持');
            }
        },
        initScannerListener() {
            window.addEventListener('keypress', this.handleScannerInput);
        },
        cleanupScanner() {
            window.removeEventListener('keypress', this.handleScannerInput);
            this.scannerBuffer = "";
            if (this.scannerTimeout) {
                clearTimeout(this.scannerTimeout);
                this.scannerTimeout = null;
            }
        },
        // 處理條碼數據
        processBarcode(barcode) {
            this.playScanSound();
            // 驗證條碼（示例：EAN-13格式）
            if (this.isValidBarcode(barcode)) {
                this.fetch(barcode);
                // 模擬真實掃碼槍的聲音反饋（可選）
                //清空緩沖區
                this.scannerBuffer = "";
            } else {
                this.$message.error(`無效的條碼格式 :${barcode}，請掃碼13比特數位`);
            }

        },


        handleScannerInput(event) {
            // 清除之前的超時定時器
            if (this.scannerTimeout) {
                clearTimeout(this.scannerTimeout);
            }

            // 處理掃碼槍輸入
            if (event.key === 'Enter') {
                // 掃碼完成，設置搜索內容並觸發搜索
                this.searchInput = this.scannerBuffer;
                this.processBarcode(this.searchInput);
                this.scannerBuffer = '';
            } else {
                // 追加字符到緩沖區
                this.scannerBuffer += event.key;

                // 設置超時定時器（300ms無輸入則清空緩沖區）
                this.scannerTimeout = setTimeout(() => {
                    this.scannerBuffer = '';
                }, 1000);
            }
        },

        fetch(barcode) {
            // 這裏應該是實際的API調用
            console.log('獲取商品信息:', barcode);

            // 模擬API返回數據
            setTimeout(() => {
                fetch({ barcode: barcode }).then(res => {
                    if (res.code != 200) {
                        this.$message.error("條碼不存在，請重新檢查條碼是否正確!")
                        return;
                    }
                    this.productData = {
                        barcode: res.data.barcode,
                        productCode: res.data.item_code,
                        productName: res.data.item_name,
                        upperLimit: res.data.upper_limit,
                        lowerLimit: res.data.lower_limit,
                    };
                    this.$emit('scan-complete', this.productData)
                    this.$message.success(`成功獲取商品 ${barcode} 的信息`);
                    //銷毀監聽時間
                    this.cleanupScanner();
                })
            }, 200);
        },
    }
}
